import { ReactElement } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useApp } from '../hooks/useApp'

/**
 * Render the page only when a user session exists; otherwise go to the login page.
 *
 * The session (user, locations, devices) lives in local storage and is wiped as a
 * whole by logout, session expiry and a session a new build could not carry over
 * (`adoptSessionForNewBuild()`). Pages that
 * dereference it unconditionally — the appliance wizard reads `locations[0]` and
 * looks up the port named in the URL — used to throw when a deep link or the
 * browser history brought the user back to them after that wipe. Without a user
 * there is nothing to render, so send them to log in instead.
 *
 * Used as a layout route (`<Route element={<RequireSession/>}>`) it guards every
 * nested route through the `Outlet`; given children it guards just those.
 */
export function RequireSession(props: { children?: ReactElement }): ReactElement {
  const app = useApp()

  if (!app.user) {
    return <Navigate to="/login" replace/>
  }

  return props.children ?? <Outlet/>
}
